import React from 'react';
import { IconProps } from '../../../DefaultIcon';

export function AgenciesIcon({ className }: IconProps) {
  return (
    <svg
      width="83"
      height="83"
      viewBox="0 0 83 83"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M77.5403 70.728L20.4371 82.8499C16.7054 83.6514 13.0488 81.272 12.2723 77.5403L0.150442 20.4622C-0.651006 16.7304 1.72829 13.0738 5.46004 12.2974L62.5632 0.150442C66.295 -0.651006 69.9516 1.72829 70.728 5.46004L82.8499 62.5632C83.6514 66.295 81.272 69.9516 77.5403 70.728Z"
        fill="#EAEDF8"
      />
      <path
        d="M41.8511 45.8828L36.3662 51.2925C35.9404 51.7183 35.9404 52.3945 36.3662 52.8203L45.5578 62.2874C45.9836 62.7132 46.6598 62.7132 47.0856 62.2874L52.4953 56.9778C52.9211 56.5771 52.9211 55.9009 52.5204 55.4751L43.4039 45.9078C43.0032 45.482 42.3019 45.457 41.8762 45.8828"
        fill="#00416B"
      />
      <path
        d="M13.5749 69.5255C13.2743 69.5255 12.9988 69.4002 12.7734 69.1999C12.3477 68.7491 12.3477 68.0478 12.7734 67.597L61.0857 20.0861C61.5366 19.6353 62.2378 19.6603 62.6886 20.0861C63.1144 20.5369 63.1144 21.2382 62.6886 21.689L14.3763 69.2249C14.1509 69.4503 13.8754 69.5505 13.5749 69.5505"
        fill="#00416B"
      />
      <path
        d="M38.2692 77.3646C37.9687 77.3646 37.6932 77.2394 37.4678 77.0391C37.042 76.5882 37.042 75.887 37.4678 75.4362L74.0589 39.4211C74.5097 38.9703 75.211 38.9953 75.6618 39.4211C76.1126 39.8719 76.0876 40.5982 75.6618 41.024L39.0707 77.0391C38.8453 77.2645 38.5698 77.3646 38.2692 77.3646Z"
        fill="#00416B"
      />
      <path
        d="M7.03777 40.7235C6.73722 40.7235 6.46173 40.6234 6.23632 40.3979C5.81055 39.9471 5.81055 39.2208 6.23632 38.7951L26.7484 18.6086C27.1992 18.1578 27.9005 18.1828 28.3513 18.6086C28.8021 19.0594 28.7771 19.7607 28.3513 20.2115L7.83922 40.3979C7.61381 40.6234 7.33831 40.7235 7.03777 40.7235Z"
        fill="#00416B"
      />
      <path
        d="M51.3177 74.4847C51.0171 74.4847 50.7416 74.3845 50.5162 74.1591L3.20574 26.0972C2.75492 25.6464 2.77997 24.9451 3.20574 24.4943C3.65655 24.0435 4.35782 24.0685 4.80864 24.4943L52.0941 72.5562C52.5199 73.007 52.5199 73.7083 52.0941 74.1591C51.8687 74.3845 51.5932 74.4847 51.2926 74.4847"
        fill="#00416B"
      />
      <path
        d="M33.2354 78.6172C32.9349 78.6172 32.6594 78.5171 32.434 78.2917L9.51757 54.9996C9.0918 54.5487 9.0918 53.8224 9.51757 53.3967C9.96838 52.9458 10.6697 52.9709 11.1205 53.3967L34.0369 76.6637C34.4627 77.1145 34.4627 77.8158 34.0369 78.2666C33.8115 78.492 33.536 78.5922 33.2354 78.5922"
        fill="#00416B"
      />
      <path
        d="M70.8032 70.3772C70.5026 70.3772 70.2021 70.252 69.9767 70.0266L24.6197 22.3655C24.1939 21.9146 24.219 21.1883 24.6698 20.7626C25.1206 20.3368 25.8469 20.3368 26.2727 20.7876L71.6297 68.4487C72.0554 68.8996 72.0304 69.6259 71.5796 70.0516C71.3542 70.252 71.0787 70.3522 70.8032 70.3522"
        fill="#00416B"
      />
      <path
        d="M77.0142 52.2948C76.7137 52.2948 76.4131 52.1696 76.1877 51.9441L36.2906 10.0184C35.8648 9.56756 35.8899 8.84125 36.3407 8.41548C36.7915 7.98971 37.5178 8.01475 37.9436 8.44052L77.8407 50.3663C78.2665 50.8171 78.2414 51.5434 77.7906 51.9692C77.5652 52.1946 77.2897 52.2948 77.0142 52.2948Z"
        fill="#00416B"
      />
      <path
        d="M57.8546 6.31141C49.4394 -2.1038 35.7647 -2.1038 27.3495 6.31141C18.9343 14.7266 18.9343 28.4013 27.3495 36.8165L41.0492 50.5163C41.9008 51.3678 43.3033 51.3678 44.1549 50.5163L57.8546 36.8165C66.2698 28.4013 66.2698 14.7266 57.8546 6.31141Z"
        fill="#00C4B3"
      />
      <path
        d="M54.123 21.5639C54.123 27.9505 48.9637 33.1098 42.5771 33.1098C36.1906 33.1098 31.0312 27.9505 31.0312 21.5639C31.0312 15.1774 36.1906 10.0181 42.5771 10.0181C48.9637 10.0181 54.123 15.1774 54.123 21.5639Z"
        fill="#EAEDF8"
      />
    </svg>
  );
}
